import {SearchLinkBox} from "../search-link.box";
import styled from "styled-components";

export const LiveSearchLinkDefaultBox = styled(SearchLinkBox)`
    &:before {
      background-position: -290px -448px;
    }
`;